// extracted by mini-css-extract-plugin
export default {"pageWrap":"Rb-z","fullWidth":"Sb-z","heading":"Tb-z","fullBleed":"Ub-z","hidden":"Vb-z"};